var _ellipse, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActionPadlockLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 76,
    viewBox: "0 0 82 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.2494,
    cy: 50.1793,
    rx: 25.2494,
    ry: 25.0191,
    fill: "#6C5CE7",
    fillOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.7377 23.9854V20.77C28.7377 12.7789 35.3796 6.30078 43.5728 6.30078C51.7661 6.30078 58.408 12.7789 58.408 20.77V23.9854H60.0563C65.5185 23.9854 69.9464 28.3041 69.9464 33.6316V59.3546C69.9464 64.682 65.5185 69.0008 60.0563 69.0008H27.0893C21.6272 69.0008 17.1992 64.6821 17.1992 59.3546V33.6316C17.1992 28.3041 21.6272 23.9854 27.0893 23.9854H28.7377ZM32.0344 20.77C32.0344 14.5547 37.2003 9.51617 43.5728 9.51617C49.9453 9.51617 55.1113 14.5547 55.1113 20.77V23.9854H32.0344V20.77ZM27.0893 27.2008C23.4479 27.2008 20.4959 30.0799 20.4959 33.6316V59.3546C20.4959 62.9062 23.4479 65.7854 27.0893 65.7854H60.0563C63.6978 65.7854 66.6497 62.9062 66.6497 59.3546V33.6316C66.6497 30.0799 63.6978 27.2008 60.0563 27.2008H27.0893Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.1901 48.9813C47.9802 48.2581 50.0418 45.7076 50.0418 42.6722C50.0418 39.0745 47.1456 36.1579 43.5728 36.1579C40.0001 36.1579 37.1038 39.0745 37.1038 42.6722C37.1038 45.7076 39.1655 48.2581 41.9556 48.9813V52.4436C41.9556 53.3431 42.6796 54.0722 43.5728 54.0722C44.466 54.0722 45.1901 53.3431 45.1901 52.4436V48.9813ZM46.8073 42.6722C46.8073 44.4711 45.3592 45.9294 43.5728 45.9294C41.7865 45.9294 40.3383 44.4711 40.3383 42.6722C40.3383 40.8733 41.7865 39.4151 43.5728 39.4151C45.3592 39.4151 46.8073 40.8733 46.8073 42.6722Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionPadlockLock);
export default __webpack_public_path__ + "static/media/action-padlock-lock.1c7d30a684aabbcc605e75aeb66bb985.svg";
export { ForwardRef as ReactComponent };